export default __webpack_public_path__ + "static/media/I-become-a-mother-DE.4b887463.png";